import Vue from "vue";
import IdVerification from "./IdVerification.vue";

function bootstrapIdVerification() {
  document.addEventListener("DOMContentLoaded", () => {
    const jsonData = JSON.parse(document.querySelector("#idParams").innerHTML);
    new Vue({
      el: "#id-verification-mount",
      render: function (createElement) {
        return createElement(IdVerification, {
          props: jsonData,
        });
      },
    });
  });
}

window.bootstrapIdVerification = bootstrapIdVerification;
